import React, { useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import ImageUploader from 'react-images-upload'
import QRCode from 'jsqr'
import ScanQr from '../../components/global/ScanQr'
import { errorMessage } from '../../constants/errorMessage'

const QRScanner = (props) => {
    const { setIsScanDisplay, setScanResult, scanResult, notify } = props
    const [result, setResult] = useState('')

    const handleImageUpload = (files) => {
        const file = files[0]
        if (file) {
            const reader = new FileReader()
            reader.onload = (event) => {
                const imageDataUrl = event.target.result
                const canvas = document.createElement('canvas')
                const context = canvas.getContext('2d')

                const img = new Image()
                img.onload = () => {
                    canvas.width = img.width
                    canvas.height = img.height
                    context.drawImage(img, 0, 0, img.width, img.height)

                    const imageData = context.getImageData(0, 0, img.width, img.height)
                    const code = QRCode(imageData.data, imageData.width, imageData.height)

                    if (code) {
                        setResult(code.data)
                        console.log(result)
                        setIsScanDisplay(code.data)
                        setScanResult(code.data)
                        setIsScanDisplay(false)
                    } else {
                        setResult('No Qr')
                        notify('error', errorMessage?.invalidQrCode)
                    }
                }
                img.src = imageDataUrl
            }
            reader.readAsDataURL(file)
        }
    }
    return (
        <div className='custom_upload_scanner'>
            <ScanQr setScanResult={setScanResult} scanResult={scanResult} setIsScanDisplay={setIsScanDisplay} notify={notify} />
            <ImageUploader
                withIcon={true}
                buttonText='Choose image'
                onChange={handleImageUpload}
                imgExtension={['.jpg', '.gif', '.png', '.gif']}
                maxFileSize={5242880}
                singleImage={true}
                fileTypeError=' Only .jpg, .gif, .png and .gif file are allowed'
                fileSizeError=' file size is too big.'
                withPreview={false}
                withLabel={false}
                errorClass='test'
            />
        </div>
    )
}

QRScanner.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    scanResult: PropTypes.string,
    setScanResult: PropTypes.func,
    notify: PropTypes.func,
    setIsScanDisplay: PropTypes.func,
    clasName: PropTypes.string,
}

QRScanner.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    scanResult: '',
    setScanResult: noop,
    notify: noop,
    setIsScanDisplay: noop,
    clasName: '',
}


function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(QRScanner)